import { RouteMeta, Route } from 'vue-router';

export default class Meta {
  private static getMetaState(route: Route): boolean {
    return JSON.parse(localStorage.getItem(`route_meta_${route.name}`) || '{}').fetched;
  }

  private static updateMetaState(route: Route, fetched: boolean): void {
    const metaStore = JSON.parse(localStorage.getItem(`route_meta_${route.name}`) || '{}');
    if (metaStore.meta) {
      metaStore.fetched = fetched;
      localStorage.setItem(`route_meta_${route.name}`, JSON.stringify(metaStore));
    }
  }

  public static get(route: Route): RouteMeta {
    if (route.params.routeMeta) {
      Meta.updateMetaState(route, true);
      return JSON.parse(route.params.routeMeta as string);
    }

    const storedMeta = Meta.getMetaState(route);
    if (storedMeta) {
      Meta.updateMetaState(route, true);
      return JSON.parse(localStorage.getItem(`route_meta_${route.name}`) || '{}').meta;
    }

    Meta.updateMetaState(route, false);
    return { from: 'default-route', to: route.name };
  }

  public static set(meta: RouteMeta): Record<string, any> {
    localStorage.setItem(`route_meta_${meta.to}`, JSON.stringify({ meta, fetched: false }));
    return {
      routeMeta: JSON.stringify(meta),
    };
  }

  public static clear(route: Route) {
    const fetched = Meta.getMetaState(route);

    if (fetched) {
      localStorage.removeItem(`route_meta_${route.name}`);
    }
  }
}
